import { EOrderTab } from '../../store/ducks/long-steel-orders/types';

export interface IHeaderRequest {
  Authorization: string;
  client_id: string;
  client_secret: string;
  sso_access: string;
  'x-api-version'?: string;
  authorization_token: string;
  'Profile-Access-Token': string;
  'x-correlation-id'?: string;
}
export interface ILocalStorage {
  getLocalStorage(key: string): ILocalStorageObj | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setLocalStorage(key: string, obj: any, customerId?: string): void;
}

export interface ILocalStorageObj {
  dateTime: number;
  customerId?: string;
  tab?: EOrderTab;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: any;
}

export enum ELocalStorageKey {
  DASHBOARD = '@egerdau-web/dashboard',
  INVOICES = '@egerdau-web/invoices',
  LONG_STEEL_ORDERS = '@egerdau-web/long-steel-orders',
  CREDIT_LIMITS = '@egerdau-web/credit-limits',
  INVOICE_CREDITS = '@egerdau-web/invoice-credits',
  SELECTED_CUSTOMER = '@egerdau-web/selected-customer',
  LONG_STEEL_SHOPPING_CART = '@egerdau-web/long-steel-shopping-cart',
  LONG_STEEL_MENU_NAVEGATION = '@egerdau-web/menu-navegation-buy-long-steel',
  CHECKOUT = '@egerdau-web/checkout'
}
